import { MapPin, Clock, Phone, Navigation } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { MAPS_LINK, MAPS_EMBED, ADDRESS, WA_DISPLAY, waLink } from "@/data/site";

export const LocationSection = () => (
  <section
    id="lokasi"
    data-testid="location-section"
    className="grain relative overflow-hidden py-24 lg:py-32"
    style={{ backgroundColor: "var(--t-dark)" }}
  >
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-6 lg:grid-cols-2 lg:px-8">
      <Reveal>
        <p className="overline-label mb-4">Lokasi Gudang</p>
        <h2 className="font-serif text-3xl tracking-tight text-white sm:text-4xl lg:text-5xl">
          Kunjungi Gudang <span className="italic" style={{ color: "var(--t-accent)" }}>Kami</span>
        </h2>
        <p className="mt-6 max-w-lg text-base leading-relaxed text-white/70">
          Lihat langsung kualitas kayu dan triplek kami sebelum membeli. Tim kami siap mendampingi
          Anda memilih material terbaik sesuai kebutuhan proyek.
        </p>
        <ul className="mt-8 space-y-5">
          <li className="flex items-start gap-4">
            <MapPin size={20} className="mt-0.5 shrink-0" style={{ color: "var(--t-accent)" }} />
            <div>
              <p className="text-sm font-semibold text-white">PT. SINAR AL MUBAROKAH</p>
              <p className="text-sm text-white/60">{ADDRESS}</p>
            </div>
          </li>
          <li className="flex items-start gap-4">
            <Clock size={20} className="mt-0.5 shrink-0" style={{ color: "var(--t-accent)" }} />
            <p className="text-sm text-white/70">Senin – Sabtu, 08.00 – 17.00 WIB</p>
          </li>
          <li className="flex items-start gap-4">
            <Phone size={20} className="mt-0.5 shrink-0" style={{ color: "var(--t-accent)" }} />
            <a href={waLink()} target="_blank" rel="noopener noreferrer" className="text-sm font-semibold text-white hover:underline">
              {WA_DISPLAY} (WhatsApp)
            </a>
          </li>
        </ul>
      </Reveal>

      <Reveal delay={0.15}>
        <div
          className="overflow-hidden rounded-[2rem] border"
          style={{ borderColor: "color-mix(in srgb, var(--t-accent) 30%, transparent)" }}
        >
          <iframe
            title="Peta lokasi PT. SINAR AL MUBAROKAH — Kalibaru, Cilincing, Jakarta Utara"
            src={MAPS_EMBED}
            data-testid="google-maps-embed"
            loading="lazy"
            className="h-[340px] w-full border-0"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          />
          <div
            className="flex flex-col items-center justify-between gap-4 p-6 sm:flex-row"
            style={{ backgroundColor: "color-mix(in srgb, var(--t-accent) 8%, transparent)" }}
          >
            <p className="text-center text-sm text-white/70 sm:text-left">
              {ADDRESS}
            </p>
            <a
              href={MAPS_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="google-maps-link"
              className="inline-flex shrink-0 items-center gap-2 rounded-full px-6 py-3 text-sm font-bold transition-transform duration-300 hover:-translate-y-0.5"
              style={{ backgroundColor: "var(--t-accent)", color: "var(--t-dark)" }}
            >
              <Navigation size={15} /> Buka Rute
            </a>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
